module.exports = {"id":"201454","name":"Faouzi Ghoulam","rating":"80","photo":"./data/images/photos/0/201454.png","club":{"name":"Naples","logo":"./data/images/clubs/Naples.png"},"positions":["DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FaouziGhoulam0.json
// module id = 1369
// module chunks = 0